/**
 * **Frekwencja, ostatnie tygodnie** — four tiles, one per week, "od 31 sie · 2 z 3", the newest
 * named "ten tydzień" when it is (owner, 26 September 2026: back from the first desk card, under a
 * missed workout and a lapse). The weeks are `model/clientWeek`'s, so the tiles and the week strip
 * above them count the same scheduled work.
 *
 * Through the wait the tiles stand at their loaded size with the bars inside them, so the answer
 * changes ink and never height.
 */

import { useTranslation } from 'react-i18next';

import type { SkeletonGate } from '~/shared/lib/useSkeletonGate';
import skel from '~/shared/ui/skeleton.module.css';

import { useHomeFormats } from '../lib/useHomeFormats';
import { ATTENDANCE_WEEKS, type AttendanceWeek } from '../model/clientWeek';
import styles from './taskBlocks.module.css';

interface AttendanceTilesProps {
  /** `null` while the schedule read is open (or failed — the block above names the failure). */
  readonly weeks: readonly AttendanceWeek[] | null;
  readonly gate: SkeletonGate;
}

export function AttendanceTiles({ weeks, gate }: AttendanceTilesProps) {
  const { t } = useTranslation();
  const { shortDate } = useHomeFormats();

  return (
    <div className={styles.stack}>
      <h4 className={styles.sectionTitle}>{t('web:tasks.week.attendance')}</h4>
      <div className={styles.tiles}>
        {weeks === null
          ? Array.from({ length: ATTENDANCE_WEEKS }, (_, index) => (
              <div className={styles.tile} key={index}>
                <p className={`${String(styles.tileLabel)} ${gate.skeleton ? String(skel.bar) : ''}`}>{' '}</p>
                <p className={`${String(styles.tileValue)} ${gate.skeleton ? String(skel.bar) : ''}`}>{' '}</p>
              </div>
            ))
          : weeks.map((week) => (
              <div className={`${String(styles.tile)} ${gate.reveal}`} key={week.startDay}>
                <p className={styles.tileLabel}>
                  {week.isCurrent
                    ? t('web:tasks.week.currentWeek')
                    : t('web:tasks.week.weekOf', { date: shortDate(week.startDay) })}
                </p>
                <p className={styles.tileValue}>{t('web:tasks.week.ratio', { done: week.done, total: week.total })}</p>
              </div>
            ))}
      </div>
    </div>
  );
}
